import { render } from "./SwiperCategoryData.vue?vue&type=template&id=0c2f73a0&scoped=true&ts=true"
import script from "./SwiperCategoryData.vue?vue&type=script&lang=ts"
export * from "./SwiperCategoryData.vue?vue&type=script&lang=ts"

import "./SwiperCategoryData.vue?vue&type=style&index=0&id=0c2f73a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2f73a0"]])

export default __exports__